var DOM_CONTENT_LOADED_EVENT = "DOMContentLoaded";
var overwritten = false;
/**
 * Overwrite `document.addEventListener('DOMContentLoaded')` as they can not be triggered by our script blocker.
 */

function applyDOMContentLoadedInitiator(doc) {
  // Only overwrite once
  if (overwritten) {
    return;
  }

  var _addEventListener = doc.addEventListener;
  Object.assign(doc, {
    addEventListener: function addEventListener(type) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      if (type === DOM_CONTENT_LOADED_EVENT) {
        // Redirect to own thread to avoid variable order lacks (e. g. Contact Form 7)
        setTimeout(function () {
          var _rest$;

          (_rest$ = rest[0]) === null || _rest$ === void 0 ? void 0 : _rest$.call(rest, new Event(DOM_CONTENT_LOADED_EVENT, {
            bubbles: true,
            cancelable: true
          }));
        }, 0);
      } else {
        _addEventListener.apply(this, [type].concat(rest));
      }
    }
  });
  overwritten = true;
}

export { applyDOMContentLoadedInitiator };